import styled from 'styled-components';

interface Props {
  icon: string;
  color?: string;
  width?: number;
  height?: number;
}

export const IconContainer = styled.div<Props>`
  width: ${props => (props.width ? `${props.width}px` : '25px')};
  height: ${props => (props.height ? `${props.height}px` : '25px')};
  background-color: ${props => props.color || 'inherit'};
  -webkit-mask: ${props => `url(${props.icon}) no-repeat center`};
  mask: ${props => `url(${props.icon}) no-repeat center`};
  cursor: pointer;
`;
